var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile"},[_c('header',[_c('div',[_c('avatar',{attrs:{"user":_vm.user}})],1),_c('h1',[_vm._v(_vm._s(_vm.user.name))])]),_c('h2',[_vm._v("Public Albums")]),_c('albums-wall',{attrs:{"albums":_vm.albums,"pages":_vm.pages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }